import { optimizelyQuizPromptImpression, optimizelyQuizModalImpression, optimizelyQuizPromptGoToTriviaQuizClick, optimizelyQuizPromptTakeQuizClick, } from '../../shared/optimizelyHelper';
import useOnScreen from 'pathfinder/modules/shared/useOnScreen';
import { useCallback, useEffect, useRef } from 'react';
import { trackQuizModalImpression, trackQuizPromptImpression } from '../QuizPrompt/track';
export default function useQuizImpTrack(track, quizPromptModuleName, quizId) {
    var quizPromptImpressionRef = useRef();
    var onScreenQuizPrompt = useOnScreen(quizPromptImpressionRef);
    var quizModalImpressionRef = useRef(null);
    var takeQuizClick = useCallback(function () {
        optimizelyQuizPromptTakeQuizClick(quizPromptModuleName);
        track.click({
            label: "".concat(quizId, " | ").concat(quizPromptModuleName, "-take-quiz"),
        });
    }, [track]);
    var goToTriviaClick = useCallback(function () {
        optimizelyQuizPromptGoToTriviaQuizClick(quizPromptModuleName);
        track.click({
            label: "".concat(quizId, " | ").concat(quizPromptModuleName, "-go-to-trivia"),
        });
    }, [track]);
    var quizModalImpression = useCallback(function () {
        optimizelyQuizModalImpression(quizPromptModuleName);
        if (quizModalImpressionRef && trackQuizModalImpression()) {
            track.impression({
                label: "".concat(quizId, " | ").concat(quizPromptModuleName, "-modal"),
            });
        }
    }, [track]);
    useEffect(function () {
        if (onScreenQuizPrompt && trackQuizPromptImpression()) {
            optimizelyQuizPromptImpression(quizPromptModuleName);
            track.impression({
                label: "".concat(quizId, " | ").concat(quizPromptModuleName, "-prompt"),
            });
        }
    }, [onScreenQuizPrompt]);
    return [quizPromptImpressionRef, quizModalImpression, takeQuizClick, goToTriviaClick];
}
